import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const tariffsApi = createApi({
    reducerPath: 'tariffsApi',
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.REACT_APP_TARIFFS_SERVICE_URL,
        prepareHeaders: (headers) => {
            const { getAccessToken } = require('../../../app/utils/authStorage');
            const token = getAccessToken();
            if (token) {
                headers.set('Content-Type', 'application/json');
                headers.set('Authorization', `Bearer ${token}`);
            }
            return headers;
        }
    }),
    endpoints: (builder) => ({
        getTariffGrid: builder.query({
            // service: 'business' | 'posting'
            query: (service) => ({ url: '/v1/grid', params: { service } }),
        }),
        getAppsTariffs: builder.query({
            query: () => ({ url: '/v1/apps' }),
        }),
        activateTrial: builder.mutation({
            query: () => ({
                url: '/v1/activate-trial',
                method: 'POST',
            }),
        }),
    }),
});

export const { useGetTariffGridQuery, useGetAppsTariffsQuery, useActivateTrialMutation } = tariffsApi;
